"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherRefNanoCourse = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const TeacherRefNanoCourse = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "32.16",
        cy: "30.59",
        r: "14.54"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "54.14",
        cy: "16.41",
        r: "6.79"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "29.96",
        cy: "6.66",
        r: "4.16"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "10.05",
        cy: "16.97",
        r: "5.98"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "12.5",
        cy: "46.93",
        r: "3.92"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "24.1",
        cy: "59.56",
        r: "2.94"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "53.18",
        cy: "45.02",
        r: "5.4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "44.18",
        y1: "38.85",
        x2: "48.55",
        y2: "41.68"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "15.59",
        y1: "44.26",
        x2: "20.57",
        y2: "40.16"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "15.36",
        y1: "19.99",
        x2: "19.65",
        y2: "22.5"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "30.36",
        y1: "11.15",
        x2: "31.09",
        y2: "15.48"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "44.76",
        y1: "22.87",
        x2: "48.36",
        y2: "20.92"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "25.04",
        y1: "56.21",
        x2: "28.24",
        y2: "44.83"
      })]
    })
  });
};
exports.TeacherRefNanoCourse = TeacherRefNanoCourse;